import React, { useState } from 'react';
import GeodezijaMenu from '../GeodezijaMenu/GeodezijaMenu';

const MenuScreen = ({ onNavigate, user }) => {
  const [showGeodezijaMenu, setShowGeodezijaMenu] = useState(false);
  
  // Check if user is eugen_p (case-insensitive, trimmed)
  const username = user?.korisnicko_ime?.trim().toLowerCase();
  let isGeodezijaEnabled = username === 'eugen_p';
  
  // Debug logging - check browser console
  console.log('MenuScreen Debug:', {
    user: user,
    korisnicko_ime: user?.korisnicko_ime,
    username_trimmed: username,
    isGeodezijaEnabled: isGeodezijaEnabled,
    comparison: `"${username}" === "eugen_p" = ${username === 'eugen_p'}`,
    userExists: !!user,
    korisnicko_imeExists: !!user?.korisnicko_ime
  });

  const handleAutomobiliClick = () => {
    onNavigate('options');
  };

  const handleGeodezijaClick = () => {
    setShowGeodezijaMenu(true);
  };

  const handleCloseGeodezijaMenu = () => {
    setShowGeodezijaMenu(false);
  };

  return (
    <>
      {showGeodezijaMenu && (
        <GeodezijaMenu onClose={handleCloseGeodezijaMenu} onNavigate={onNavigate} />
      )}
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #CAE0BC 0%, #EAFAEA 100%)',
        fontFamily: 'Arial, sans-serif',
        padding: '20px'
      }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '20px',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '500px'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{ 
            marginBottom: '10px',
            width: '120px',
            height: '120px',
            borderRadius: '12px',
            backgroundColor: 'rgba(108, 139, 88, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
            overflow: 'hidden',
            boxShadow: '0 4px 12px rgba(108, 139, 88, 0.2)'
          }}>
            <img 
              src="/zzf.png" 
              alt="ZZF Logo" 
              style={{
                width: '100px',
                height: '100px',
                objectFit: 'contain'
              }}
            />
          </div>
          <h1 style={{ 
            margin: 0, 
            fontSize: '2rem',
            background: 'linear-gradient(135deg, #6C8B58, #8BA888)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: 'bold'
          }}>ZZF</h1>
          <p style={{ 
            color: '#666', 
            margin: '10px 0 0 0',
            fontSize: '1.1rem'
          }}>Odaberite sekciju</p>
        </div>

        {/* Menu Buttons */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {/* Automobili Button */}
          <button
            onClick={handleAutomobiliClick}
            style={{
              width: '100%',
              padding: '25px',
              background: '#6C8B58',
              color: 'white',
              border: 'none',
              borderRadius: '15px',
              fontSize: '1.2rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 8px 20px rgba(108, 139, 88, 0.3)',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '15px'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-3px)';
              e.target.style.boxShadow = '0 12px 25px rgba(108, 139, 88, 0.4)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 8px 20px rgba(108, 139, 88, 0.3)';
            }}
          >
            <span>🚗</span>
            <span>Automobili</span>
          </button>

          {/* Geodezija Button */}
          <button
            onClick={handleGeodezijaClick}
            disabled={!isGeodezijaEnabled}
            style={{
              width: '100%',
              padding: '25px',
              background: isGeodezijaEnabled ? '#7B9C92' : '#ccc',
              color: 'white',
              border: 'none',
              borderRadius: '15px',
              fontSize: '1.2rem',
              fontWeight: 'bold',
              cursor: isGeodezijaEnabled ? 'pointer' : 'not-allowed',
              boxShadow: isGeodezijaEnabled ? '0 8px 20px rgba(123, 156, 146, 0.3)' : 'none',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '15px',
              opacity: isGeodezijaEnabled ? 1 : 0.6
            }}
            onMouseOver={(e) => {
              if (isGeodezijaEnabled) {
                e.target.style.transform = 'translateY(-3px)';
                e.target.style.boxShadow = '0 12px 25px rgba(123, 156, 146, 0.4)';
              }
            }}
            onMouseOut={(e) => {
              if (isGeodezijaEnabled) {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 8px 20px rgba(123, 156, 146, 0.3)';
              }
            }}
          >
            <span>📐</span>
            <span>Geodezija</span>
          </button>
          
          {/* Nazad Button */}
          <button
            onClick={() => {
              localStorage.removeItem('auth_token');
              localStorage.removeItem('user_data');
              window.location.reload();
            }}
            style={{
              width: '100%',
              padding: '18px',
              background: '#cccccc',
              color: '#333',
              border: 'none',
              borderRadius: '12px',
              fontSize: '1rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
            }}
          >
            Nazad
          </button>
        </div>

        {/* Footer */}
        <div style={{ textAlign: 'center', marginTop: '30px' }}>
          <p style={{ color: 'rgba(108, 139, 88, 0.7)', fontSize: '12px', margin: 0 }}>
            © 2025 ZZF - Zavod za fotogrametriju d.d.
          </p>
        </div>
      </div>
    </div>
    </>
  );
};

export default MenuScreen;
